import { useEffect } from 'react';

export const useEscapeKey = (onEscape: () => void, isEditing: boolean) => {
  useEffect(() => {
    if (!isEditing) return () => {};

    const handleKeyDown = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        onEscape();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onEscape, isEditing]);
};
